export function showModal(type, data) {
    let tmpElement = document.getElementById('wrapper');
    tmpElement.className = 'blur';
    return {
        type: 'SHOW_MODAL',
        content: modalData(type, data)
    };
}

export function hideModal() {
    let tmpElement = document.getElementById('wrapper');
    tmpElement.className = '';
    return {
        type: 'HIDE_MODAL',
        content: {
            title: '',
            description: '',
        }
    };
}

function modalData(type, data) {
    switch (type){
        case 'NONCOMMERCIALCARD_REPORT_MODAL':
            return {
                type: 'NONCOMMERCIALCARD_REPORT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'AGGREGATEDCARD_REPORT_MODAL':
            return {
                type: 'AGGREGATEDCARD_REPORT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'STATIONTOTAL_REPORT_MODAL':
            return {
                type: 'STATIONTOTAL_REPORT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'UNCOVERED_REPORT_MODAL':
            return {
                type: 'UNCOVERED_REPORT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'CASH_REPORT_MODAL':
            return {
                type: 'CASH_REPORT_MODAL',
                title: '',
                description: '',
                data: data
            };

        case 'BARRELBALANCE_REPORT_MODAL':
            return {
                type: 'BARRELBALANCE_REPORT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'WRONGLEVEL_REPORT_MODAL':
            return {
                type: 'WRONGLEVEL_REPORT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'PERIODIC_REPORT_MODAL':
            return {
                type: 'PERIODIC_REPORT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'LEFTOVERS_REPORT_MODAL':
            return {
                type: 'LEFTOVERS_REPORT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'PROFITTRANSACTIONS_REPORT_MODAL':
            return {
                type: 'PROFITTRANSACTIONS_REPORT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'ZREPORT_REPORT_MODAL':
            return {
                type: 'ZREPORT_REPORT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'COMPANYREGISTERS_REPORT_MODAL':
            return {
                type: 'COMPANYREGISTERS_REPORT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'CLIENTCARDOPERATIONS_REPORT_MODAL':
            return {
                type: 'CLIENTCARDOPERATIONS_REPORT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'FUEL_COMING_MODAL':
            return {
                type: 'FUEL_COMING_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'PRICE_MODAL':
            return {
                type: 'PRICE_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'PRICE_EDIT_MODAL':
            return {
                type: 'PRICE_EDIT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'PRICE_DELETE_MODAL':
            return {
                type: 'PRICE_DELETE_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'INFO_MODAL':
            return {
                type: 'INFO_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'CARD_MODAL':
            return {
                type: 'CARD_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'CARD_EDIT_MODAL':
            return {
                type: 'CARD_EDIT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'CARD_DELETE_MODAL':
            return {
                type: 'CARD_DELETE_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'COUPON_MODAL':
            return {
                type: 'COUPON_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'COUPON_LOAD_MODAL':
            return {
                type: 'COUPON_LOAD_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'COUPON_EDIT_MODAL':
            return {
                type: 'COUPON_EDIT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'COUPON_DELETE_MODAL':
            return {
                type: 'COUPON_DELETE_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'COUPON_DELETE_ALL_MODAL':
            return {
                type: 'COUPON_DELETE_ALL_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'COMPANY_MODAL':
            return {
                type: 'COMPANY_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'COMPANY_EDIT_MODAL':
            return {
                type: 'COMPANY_EDIT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'COMPANY_DELETE_MODAL':
            return {
                type: 'COMPANY_DELETE_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'DEPARTMENT_CREATE_MODAL':
            return {
                type: 'DEPARTMENT_CREATE_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'DEPARTMENT_EDIT_MODAL':
            return {
                type: 'DEPARTMENT_EDIT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'DEPARTMENT_DELETE_MODAL':
            return {
                type: 'DEPARTMENT_DELETE_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'EMPLOYEE_CREATE_MODAL':
            return {
                type: 'EMPLOYEE_CREATE_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'EMPLOYEE_EDIT_MODAL':
            return {
                type: 'EMPLOYEE_EDIT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'EMPLOYEE_DELETE_MODAL':
            return {
                type: 'EMPLOYEE_DELETE_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'REGISTER_CREATE_MODAL':
            return {
                type: 'REGISTER_CREATE_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'REGISTER_EDIT_MODAL':
            return {
                type: 'REGISTER_EDIT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'REGISTER_DELETE_MODAL':
            return {
                type: 'REGISTER_DELETE_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'LOAN_DELETE_MODAL':
            return {
                type: 'LOAN_DELETE_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'LOAN_CREATE_MODAL':
            return {
                type: 'LOAN_CREATE_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'COMPANY_MOVEMENT_CREATE_MODAL':
            return {
                type: 'COMPANY_MOVEMENT_CREATE_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'COMPANY_MOVEMENT_EDIT_MODAL':
            return {
                type: 'COMPANY_MOVEMENT_EDIT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'COMPANY_MOVEMENT_DELETE_MODAL':
            return {
                type: 'COMPANY_MOVEMENT_DELETE_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'REGISTER_AUDIT_CREATE_MODAL':
            return {
                type: 'REGISTER_AUDIT_CREATE_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'REGISTER_AUDIT_EDIT_MODAL':
            return {
                type: 'REGISTER_AUDIT_EDIT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'REGISTER_AUDIT_DELETE_MODAL':
            return {
                type: 'REGISTER_AUDIT_DELETE_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'TRK_EDIT_MODAL':
            return {
                type: 'TRK_EDIT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'BARREL_EDIT_MODAL':
            return {
                type: 'BARREL_EDIT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'OWNER_MODAL':
            return {
                type: 'OWNER_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'OWNER_EDIT_MODAL':
            return {
                type: 'OWNER_EDIT_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'OWNER_DELETE_MODAL':
            return {
                type: 'OWNER_DELETE_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'OWNER_SYNCHRONIZATION_MODAL':
            return {
                type: 'OWNER_SYNCHRONIZATION_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'STATION_MODAL':
            return {
                type: 'STATION_MODAL',
                title: '',
                description: '',
                data: data
            };
        case 'STATION_EDIT_MODAL':
            return {
                type: 'STATION_EDIT_MODAL',
                title: '',
                description: '',
                data: data
        };
        case 'STATION_DELETE_MODAL':
            return {
                type: 'STATION_DELETE_MODAL',
                title: '',
                description: '',
                data: data
        };
        case 'PETROLBOX_CLIENT_MODAL':
            return{
                type: 'PETROLBOX_CLIENT_MODAL',
                title: '',
                description: '',
                data: data
            }
        case 'PETROLBOX_CLIENT_EDIT_MODAL':
            return{
                type: 'PETROLBOX_CLIENT_EDIT_MODAL',
                title: '',
                description: '',
                data: data
            }
        case 'PETROLBOX_CLIENT_DELETE_MODAL':
            return{
                type: 'PETROLBOX_CLIENT_DELETE_MODAL',
                title: '',
                description: '',
                data: data
            }
        default:
            break;
    }
}
